// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalUpdate_root__1cSrs","footer":"ModalUpdate_footer__14xS3"};